import ReaderModeStylePopup from './ReaderModeStylePopup';

export default ReaderModeStylePopup;